import { Vector2 } from './types';

export class SimplePlayerExplosion {
  position: Vector2;
  particles: SimpleParticle[] = [];
  alive: boolean = true;
  timer: number = 0;
  maxTime: number = 3.0;

  constructor(x: number, y: number) {
    this.position = { x, y };
    
    // 簡単な爆発パーティクルを作成
    for (let i = 0; i < 50; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 100 + Math.random() * 200;
      this.particles.push(new SimpleParticle(
        x, y,
        Math.cos(angle) * speed,
        Math.sin(angle) * speed
      ));
    }
  }

  update(deltaTime: number): void {
    this.timer += deltaTime;
    
    this.particles.forEach(particle => particle.update(deltaTime));
    
    if (this.timer >= this.maxTime) {
      this.alive = false;
    }
  }

  render(ctx: CanvasRenderingContext2D): void {
    const alpha = Math.max(0.1, 1 - (this.timer / this.maxTime));
    
    ctx.save();
    ctx.globalAlpha = alpha;
    
    this.particles.forEach(particle => particle.render(ctx));
    
    // 中央に白い光
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    const radius = 50 * (1 - this.timer / this.maxTime);
    ctx.arc(this.position.x, this.position.y, radius, 0, Math.PI * 2);
    ctx.fill();
    
    ctx.restore();
  }
}

class SimpleParticle {
  position: Vector2;
  velocity: Vector2;
  color: string;
  size: number;

  constructor(x: number, y: number, vx: number, vy: number) {
    this.position = { x, y };
    this.velocity = { x: vx, y: vy };
    this.color = ['#ff4444', '#ff8844', '#ffff44', '#ffffff'][Math.floor(Math.random() * 4)];
    this.size = 2 + Math.random() * 4;
  }

  update(deltaTime: number): void {
    this.position.x += this.velocity.x * deltaTime;
    this.position.y += this.velocity.y * deltaTime;
    
    this.velocity.x *= 0.98;
    this.velocity.y *= 0.98;
    this.velocity.y += 50 * deltaTime;
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = this.color;
    ctx.beginPath();
    ctx.arc(this.position.x, this.position.y, this.size, 0, Math.PI * 2);
    ctx.fill();
  }
}